import React from "react";
import { Result, Button } from "antd";
import { useNavigate } from "react-router-dom";
import { WarningOutlined } from "@ant-design/icons";

const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <div style={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
      <Result
        icon={<WarningOutlined style={{ color: "#faad14" }} />}
        status="403"
        title="Unauthorized Access"
        subTitle="You do not have permission to access this page."
        extra={
          <Button type="primary" onClick={() => navigate("/dashboard")}>
            Go to Dashboard
          </Button>
        }
      />
    </div>
  );
};

export default Unauthorized;
